var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useContext } from 'react';
import { NO_RESET_KEY } from '../../constants';
const FormRootContext = createContext({
    errors: {},
    fieldsToBeSet: {},
    focusedField: '',
    formData: {},
    injectedErrors: {},
    isPristine: true,
    isValidating: false,
    methods: {
        focusField: () => {
        },
        forceValidate: () => {
        },
        injectErrors: () => {
        },
        registerFieldErrors: () => {
        },
        reset: () => {
        },
        scrollFieldIntoView: () => {
        },
        setDirty: () => {
        },
        setIsPristine: () => {
        },
        setFieldsValue: () => {
        },
        setResetFlag: () => {
        },
        setResetRecords: () => {
        },
    },
    onWizardCancel: () => {
    },
    onWizardSuccess: () => {
    },
    resetFlag: { resetKey: NO_RESET_KEY },
    resetRecords: {},
    scrolledField: '',
    setWizardStep: () => {
    },
    wizardStep: undefined,
});
export const useFormRoot = () => {
    _react_refresh_temp_3();
    return useContext(FormRootContext);
};
_react_refresh_temp_3(useFormRoot, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
export const FormRootProvider = memo(_react_refresh_temp_1 = ({ children, value }) => {
    return (_jsx(FormRootContext.Provider, { value: value, children: children }));
});
$RefreshReg$(_react_refresh_temp_1, "FormRootProvider$memo");
_react_refresh_temp_2 = FormRootProvider;
$RefreshReg$(_react_refresh_temp_2, "FormRootProvider");
FormRootContext.displayName = 'FormRootContext';
FormRootProvider.displayName = 'FormRootProvider';
